import React, { useState } from 'react';
import { MailIcon, CheckCircleIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
export function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setEmail('');
    }
  };
  return <section className="py-16 bg-primary-600" aria-labelledby="newsletter-heading" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4" data-id="element-220">
        <div className="max-w-2xl mx-auto text-center" data-id="element-221">
          <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-222">
            <MailIcon className="w-8 h-8 text-white" data-id="element-223" />
          </div>

          <h2 id="newsletter-heading" className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-224">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-primary-100 mb-8" data-id="element-225">
            Get exclusive deals, new product alerts, and tech tips delivered to
            your inbox. Join 10,000+ subscribers!
          </p>

          {isSubscribed ? <div className="flex items-center justify-center gap-2 text-white bg-white/10 rounded-lg py-4 px-6" data-id="element-226">
              <CheckCircleIcon className="w-6 h-6 text-green-400" data-id="element-227" />
              <span className="font-medium" data-id="element-228">Thank you for subscribing!</span>
            </div> : <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-id="element-229">
              <Input type="email" placeholder="Enter your email address" value={email} onChange={e => setEmail(e.target.value)} required className="bg-white/10 border-white/20 text-white placeholder:text-white/60 flex-1" data-id="element-230" />
              <Button type="submit" variant="secondary" size="lg" data-id="element-231">
                Subscribe
              </Button>
            </form>}

          <p className="mt-4 text-xs text-primary-200" data-id="element-232">
            By subscribing, you agree to our Privacy Policy. Unsubscribe
            anytime.
          </p>
        </div>
      </div>
    </section>;
}